import { DsplNode, VScalar } from '../vm/interface'
import { skin } from './skin'

export class PickMarker {
  draw = (
    c: CanvasRenderingContext2D,
    x: number,
    y: number,
    w: number,
    h: number,
    { meta }: { meta?: { index: number, scalar: VScalar, scalarIndex: number, dspl: DsplNode } }
  ) => {
    const currentIndex = meta!.dspl.frontend.scalars[meta!.scalar.ptr]
    // console.log(currentIndex)
    if (meta!.index === currentIndex) {
      c.save()
      // @ts-ignore
      c.strokeStyle = skin.$.colors[['purple', 'green', 'cyan', 'yellow'][meta!.scalarIndex % 4]]
      c.lineWidth = 1
      // c.clearRect(x, y, w, h)
      // console.log(meta!.scalar)

      c.strokeRect(
        x,
        y,
        w,
        h
      )
      c.restore()
    }
  }
}
